import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-width: 500px;
  margin-bottom: -10px;
  border-radius: 6px;
  border: 1px solid #eaeaea;
  background: #fff;
  flex-grow: auto;
  padding: 15px 15px 20px 15px;
`;

export const Title = styled.div`
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
`;

export const SubTitle = styled.div`
  color: #000;
  font-family: Poppins;
  font-size: ${props => props.fontSize || '14px'};
  font-style: normal;
  font-weight: 400;
`;

export const Wrapper = styled.div`
  max-height: calc(100% - 10px);
  padding 5px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  overflow: auto;
  @media screen and (min-width: 1800px) {
    gap: 14px;
  }
`;

export const Center = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
`;

export const Wrap = styled.div`
  display: flex;
  gap: 10px;
  @media screen and (min-width: 1800px) {
    gap: 14px;
  }
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 770px;
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  /* Default to right-align */
  justify-content: flex-end;

  /* When container has exactly two direct children */
  &:has(> :first-child:not(:only-child)) {
    justify-content: space-between;
  }
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  min-width: fit-content;
  align-items: center;
  gap: 8px;
  color: #007ade;
  font-size: 14px;
  padding: 0px 15px;
  border: 1px solid #2087e1;
  border-radius: 3px;
  height: 28px;
  transition: all 0.3s ease-in;
  background-color: #e6f5fd;
  &:hover {
    color: white;
    cursor: pointer;
    background-color: #007ade;
    border: 1px solid #2087e1;
  }
  &:disabled {
    color: #737373;
    border-color: #737373;
    background-color: #f0f0f0;
    cursor: not-allowed;
  }
`;

export const EventIdMessageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

export const MessageDetails = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: center;
`;

export const MessageTitle = styled.span`
  font-size: 15px;
  font-weight: bold;
`;

export const MessageId = styled.span`
  padding: 0px 10px;
  font-size: 12px;
  border: 1px solid #cfcfcf;
  border-radius: 4px;
`;

export const Highlight = styled.span`
  border-radius: 29px;
  background: #ededed;
  width: 45px;
  height: 24px;
  color: #737373;

  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  vertical-align: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;

export const Btn = styled.div`
  display: flex;
  justify-content: end;
  gap: 5px;
  align-items: center;
  color: #007ade;

  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in;

  &:hover {
    font-weight: 600;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
`;

export const FlexColumn = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const FixedColumn = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const Info = styled.span`
  color: #787678;
  display: flex;
  align-items: flex-end;
  width: fit-content
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
`;

export const Bold = styled.span`
  padding-left: 4px;
  color: #787678;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
`;
